/* Product card hover / swipe / dots image slideshow.
   One delegated script for all cards (replaces the per-card inline <script>). */
(function () {
  if (window.__cardSlideshowInit) return;
  window.__cardSlideshowInit = true;

  var state = new WeakMap();

  function getState(wrapper) {
    var s = state.get(wrapper);
    if (s) return s;
    var slideshow = wrapper.querySelector('.product-image-slideshow');
    var images = slideshow ? slideshow.querySelectorAll('img') : [];
    s = { images: images, dots: wrapper.querySelectorAll('.product-dots .dot'), index: 0, timer: null, startX: 0 };
    state.set(wrapper, s);
    if (images.length === 1) images[0].style.opacity = '1';
    return s;
  }

  function show(s, idx) {
    var n = s.images.length;
    s.index = ((idx % n) + n) % n;
    for (var i = 0; i < n; i++) s.images[i].style.opacity = i === s.index ? '1' : '0';
    for (var j = 0; j < s.dots.length; j++) s.dots[j].classList.toggle('active', j === s.index);
  }

  function stop(s) {
    if (s.timer) { clearInterval(s.timer); s.timer = null; }
  }

  // Swap the transparent placeholder for the real second image (once)
  function loadSecondary(wrapper) {
    if (!wrapper || wrapper.__secondaryLoaded) return;
    wrapper.__secondaryLoaded = true;
    var imgs = wrapper.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }

  // When a card is actually on screen, fetch its second image when the browser is idle
  var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
  var viewObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        viewObserver.unobserve(en.target);
        idle(function () { loadSecondary(en.target); });
      }
    });
  }) : null;

  function observeWrappers(root) {
    if (!viewObserver) return;
    var list = (root || document).querySelectorAll('.product-media-wrapper:not([data-sec-obs])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-sec-obs', '1');
      viewObserver.observe(list[i]);
    }
  }
  observeWrappers();
  if ('MutationObserver' in window) {
    var moTimer = null;
    new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () { moTimer = null; observeWrappers(); }, 300);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function wrapperOf(el) {
    return el && el.closest ? el.closest('.product-media-wrapper') : null;
  }

  // Desktop hover autoplay
  document.addEventListener('mouseenter', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('product-media-wrapper')) return;
    var s = getState(t);
    if (s.images.length <= 1) return;
    loadSecondary(t);
    stop(s);
    s.timer = setInterval(function () { show(s, s.index + 1); }, 2200);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('product-media-wrapper')) return;
    var s = getState(t);
    if (s.images.length <= 1) return;
    stop(s);
    show(s, 0);
  }, true);

  // Mobile swipe
  document.addEventListener('touchstart', function (e) {
    var w = wrapperOf(e.target);
    if (!w) return;
    var s = getState(w);
    if (s.images.length <= 1) return;
    loadSecondary(w);
    s.startX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var w = wrapperOf(e.target);
    if (!w) return;
    var s = getState(w);
    if (s.images.length <= 1) return;
    var diff = s.startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) show(s, diff > 0 ? s.index + 1 : s.index - 1);
  }, { passive: true });

  // Dots click
  document.addEventListener('click', function (e) {
    var dot = e.target && e.target.closest ? e.target.closest('.product-dots .dot') : null;
    if (!dot) return;
    var w = wrapperOf(dot);
    if (!w) return;
    var s = getState(w);
    if (s.images.length <= 1) return;
    var idx = Array.prototype.indexOf.call(s.dots, dot);
    if (idx < 0) return;
    loadSecondary(w);
    show(s, idx);
    stop(s);
  });
})();
